import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useGetSpecialOffersQuery } from "../redux/services/api";
import { createExcerpt } from "../utils/excerpt";
import { useTranslation } from "../hooks/useTranslation";
import { useLanguage } from "../contexts/LanguageContext";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const SpecialOffers = () => {
  const navigate = useNavigate();
  const { t, isArabic } = useTranslation();
  const { getLocalizedPath } = useLanguage();
  const swiperRef = useRef(null);

  // Use RTK Query to fetch offers
  const { data: offersData, isLoading: loading } = useGetSpecialOffersQuery();
  const offers =
    offersData?.offers?.filter((offer) => offer && offer.is_active) || [];

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      offset: 100,
    });
  }, []);

  const handleLearnMore = (offerId) => {
    navigate(getLocalizedPath(`/offer/${offerId}`));
  };

  const handleViewAllOffers = () => {
    navigate(getLocalizedPath("/offers"));
  };

  if (loading) {
    return (
      <section className="special-offers-dark" id="services">
        <div className="container">
          <h2 className="section-title-dark">{t("offers.title")}</h2>
          <div className="offers-container-dark">
            <div className="loading-placeholder">
              <div className="loading-spinner"></div>
              <p>Loading offers...</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (offers.length === 0) {
    return null;
  }

  return (
    <section className="special-offers-dark" id="services">
      <div className="container">
        <h2
          className="section-title-dark"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {t("offers.title")}
        </h2>
        <div className="offers-container-dark">
          <Swiper
            key={`offers-${isArabic ? "rtl" : "ltr"}`}
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            navigation={true}
            pagination={{
              enabled: offers.length > 1,
              clickable: true,
              dynamicBullets: false,
              type: "bullets",
            }}
            dir={isArabic ? "rtl" : "ltr"}
            breakpoints={{
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            className="offers-carousel-dark"
          >
            {offers.map((offer, index) => (
              <SwiperSlide key={offer.id}>
                <div
                className="offer-card-dark"
                data-aos="zoom-in"
                data-aos-delay={`${200 + index * 100}`}
              >
                <div className="offer-image-dark">
                  {offer.image_url ? (
                    <img
                      src={offer.image_url}
                      alt={offer.title}
                      className="offer-img-dark"
                      onError={(e) => {
                        e.target.style.display = "none";
                        if (e.target.nextSibling) {
                          e.target.nextSibling.style.display = "flex";
                        }
                      }}
                    />
                  ) : (
                    <span style={{ color: "#ccc" }}>{offer.title}</span>
                  )}
                </div>
                <h3 className="offer-title-dark">
                  {isArabic && offer.title_ar ? offer.title_ar : offer.title}
                </h3>
                <p className="offer-description-dark">
                  {createExcerpt(
                    isArabic && offer.content_ar
                      ? offer.content_ar
                      : offer.content,
                    20
                  )}
                </p>
                <button
                  className="btn-more"
                  onClick={() => handleLearnMore(offer.id)}
                >
                  {t("offers.readMore")}
                </button>
              </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="view-all-offers">
          <button className="btn btn-secondary" onClick={handleViewAllOffers}>
            {t("offers.viewAll")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default SpecialOffers;
